import http from "./config/NetworkClient";

export default class MatchingQuestionnaireApi {
  static async getQuestionnaire() {
    const response = await http.getWithoutAuth("/client/matching/questions");
    return response;
  }

  static async submitQuestion(payload, isLoggedIn) {
    const response = isLoggedIn
      ? await http.post(`/client/matching/question-submissions`, payload)
      : await http.postWithoutAuth(
          `/client/matching/question-submissions`,
          payload
        );
    return response;
  }

  static async topMatchesTherapist(id) {
    const response = await http.getWithoutAuth(
      `/client/matching/recommendations/${id}/result`
    );
    return response;
  }
  static async topMatchesTherapistV2(id) {
    const response = await http.getWithoutAuth(
      `/client/matching/v2/recommendations/${id}/result`
    );
    return response;
  }
}
